import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client, throwFriendlyApiError } from '../common';

type Variables = { phone: string };
export type StartOtpResponse = {};

export const useStartOtp = createMutation<
  StartOtpResponse,
  Variables,
  AxiosError
>({
  mutationFn: async ({ phone }) =>
    client({
      url: 'v2/login/otp',
      method: 'POST',
      data: { phone },
    })
      .then((response) => response.data)
      .catch((err: any) => throwFriendlyApiError(err, 'send code')),
});
